package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.sections.sports.ALL_SPORTS
import com.arena_web.ui.sections.sports.SportLandingContent
import com.varabyte.kobweb.core.Page

@Page("/basketball")
@Composable
fun BasketballPage() = SportLandingContent(ALL_SPORTS.first { it.slug == "basketball" })
